/**
 * OG-Types meta tag options
 */

export enum ogTypes {
  jobList = 'job:list',
  jobMap = 'job:map',
  jobVacancy = 'job:vacancy',
  article = 'article',
}